export default __webpack_public_path__ + "static/imgWarrantypng-a2d737290609f034e11dda7df5e20ce3.png";